// extracted by mini-css-extract-plugin
var _1 = "ColumnSelectPopup_checkbox__mmnMe";
var _2 = "ColumnSelectPopup_selectDefaultButton__osniU";
export { _1 as "checkbox", _2 as "selectDefaultButton" }
